import { render, staticRenderFns } from "./EmailLogs.vue?vue&type=template&id=56128a41&scoped=true&"
import script from "./EmailLogs.vue?vue&type=script&lang=js&"
export * from "./EmailLogs.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogs.vue?vue&type=style&index=0&id=56128a41&scoped=true&lang=css&"
import style1 from "./EmailLogs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56128a41",
  null
  
)

export default component.exports